import { useQuery } from 'react-query';
import { useState } from 'react';
import { getTalents } from '../api/talentsApi';
import { TABLE } from '../consts';
import { TALENT_PARAMS } from '../consts/requestParamsKeys';
import { Sort } from '../interfaces/apiRequest.interface';
import { TALENTS_PAGE_FILTERS } from '../pages/TalentsListPage/talentsListPageFilters';
import { isLinkedinUrl } from '../utils';
import { ActiveFilters } from './useTablePageParams';

const querySearchInColumns = [
  TALENT_PARAMS.FULL_NAME,
  TALENT_PARAMS.CURRENT_COMPANY_NAME,
  TALENT_PARAMS.CURRENT_JOB_TITLE,
];

type GetTalentsResult = {
  error: unknown,
  data: TalentsListResponse,
  isLoading: boolean,
  isError?: boolean,
}

export const useGetTalents = (
  activeFilters: ActiveFilters,
  currentPage: number,
  activeSort: Sort,
): GetTalentsResult => {
  const searchColumns = `{${querySearchInColumns.join(',')}}`;
  const searchQuery = activeFilters[TALENTS_PAGE_FILTERS.QUERY]?.[0];

  const {
    error,
    data,
    isLoading,
  } = useQuery(['talents', currentPage, activeFilters, activeSort], () =>  getTalents({
    page: currentPage,
    limit: TABLE.ROWS_PER_PAGE,
    contains: {
      [searchColumns]: searchQuery,
    },
    in: {
      [TALENT_PARAMS.CURRENT_COMPANY_NAME]: activeFilters[TALENTS_PAGE_FILTERS.COMPANY],
    },
    order: activeSort,
  }),
  {
    keepPreviousData: true,
  },
  );

  return {
    error,
    data,
    isLoading,
  };
};

export const useGetTalentsByLinkedIn = (): GetTalentsResult & {
  setLinkedInUrl: (value: string) => void,
  linkedInUrl: string,
} => {
  const [linkedInUrl, setLinkedInUrl] = useState('');
  const {
    error,
    data,
    isLoading,
  } = useQuery(['talent_by_linkedInUrl', linkedInUrl], () =>  {
    if (isLinkedinUrl(linkedInUrl)) {
      return getTalents({
        where: { '{linkedinUrl}': linkedInUrl },
        in: {},
        order: { firstName: '+' },
        page: 1,
        limit: 200,
      });
    }

    return { results: [] } as TalentsListResponse;
  });

  return {
    linkedInUrl,
    error,
    data,
    isLoading,
    setLinkedInUrl,
  };
};
